import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'

import clientSDK from '../../../../ClientSDK'
import {
  axiosErrorHandler,
  IThunkReject,
} from '../../../../Util/axiosErrorHandler'

interface IResponse {
  status: 'success'
  customerUuid: string
}

export const deleteCustomer = createAsyncThunk<
  IResponse,
  string,
  IThunkReject<any>
>('removeCustomer/delete', async (customerUuid, { rejectWithValue }) => {
  let deleteResponse: IResponse | null = null

  try {
    const promise = clientSDK
      .instance()
      .delete<IResponse>(`/customers/${customerUuid}`)

    const result = await promise
    deleteResponse = {
      status: result.data.status,
      customerUuid,
    }
  } catch (error) {
    const handleAxiosError = axiosErrorHandler<any>(res => res)
    const generatedError = handleAxiosError(error as Error | AxiosError)
    return rejectWithValue(generatedError)
  }

  return deleteResponse
})
